
import * as React from 'react';
import { changeAttachmentType } from 'bom/components/utils/partsSelectionFunctions';
import { RadioGroup, FormControlLabel, Radio } from '@mui/material';
import { getLegacyBomControlProps } from 'bom/components/LegacyBomCheckboxIcon';
import {
  SELECT_ATTACHMENT_TYPE_ON_LOAD,
} from 'actions';
import { state } from '__common/store';
import { isNxtHorizon, isSMFamily } from '__common/constants/products';
export default class AttachmentTypes extends React.Component<attachmentTypeComponentState, {}> {
  UNSAFE_componentWillMount() {
    const { dispatch, selectedGroup } = this.props;
    dispatch(SELECT_ATTACHMENT_TYPE_ON_LOAD(selectedGroup));
  }

  changeAttachmentType(attachmentType: string) {
    changeAttachmentType(attachmentType);
  }

  parseTypes = (attachmentTypes: string[]) => {
    return attachmentTypes.map(type => Object({ label: type, value: type, key: type.toLowerCase().split(' ').join('-') }));
  }

  render() {
    const { attachmentTypes, selectedGroup, legacyCheckboxIcons = false } = this.props;
    const {bom: { selectedAttachmentType }, projectConfiguration: { productId }} = state();
    const shouldHideAttachmentSelection = (isSMFamily(productId) || isNxtHorizon(productId)) && (selectedGroup === "2 Piece Aluminum Standoff" && (!selectedAttachmentType?.standoffs || !selectedAttachmentType.standoffs.length))
    
    const types = this.parseTypes(attachmentTypes);
    return (
      <div className={`attachment-types-selector ${shouldHideAttachmentSelection && `hide`}`}>
        {/* <RadioGroup
          id="attachment-selection-control-group-radios"
          name="attachment-types"
          value={selectedGroup}
          controls={types}
          onChange={(attachmentType) => this.changeAttachmentType(attachmentType)}
          checkedRadioIcon={(<Icon>check</Icon>)}
          uncheckedRadioIcon={(<Icon>check</Icon>)}
          inline={true}
        /> */}
        <RadioGroup
          row
          name="attachment-types"
          aria-label="Roof attachment type"
          value={selectedGroup}
          onChange={(e) => this.changeAttachmentType(e.target.value)}
          className={`attachment-type-radio-group${legacyCheckboxIcons ? ' attachment-type-radio-group--legacy' : ''}`}
        >
          {types.map((type) => (
            <FormControlLabel
              key={type.key}
              value={type.value}
              control={<Radio {...getLegacyBomControlProps(legacyCheckboxIcons)} />}
              label={type.label}
              className="attachment-type-radio"
            />
          ))}
        </RadioGroup>
      </div>
    );
  }
}
